import { Select, Spin, Empty, } from "antd";
import { SelectProps } from "antd/lib/select";
import { isArray } from "lodash";
import React from "react";
import { APostLists } from "services/v1/tenant";

export interface TenantProps {
  multiple?: boolean
  onChange: (value?: number[]) => void
  defaultValue?: {label: string, value: number, key: number}[]
}

interface TenantState {
  options: SelectProps<number>['options']
  loading: boolean
  defaultValue?: number[]
  value: number[]
}

export class TenantSelect extends React.Component<TenantProps, TenantState> {
  constructor(props: TenantProps) {
    super(props)
    if (props.defaultValue) {
      this.state.options = props.defaultValue
      this.state.defaultValue = props.defaultValue.map(item => item.value)
      this.state.value = this.state.defaultValue
    }
  }

  componentDidMount() {
    this.onSelect('')
  }

  state: TenantState = {
    options: [],
    loading: false,
    value: []
  }

  timer:any = undefined

  onSelect = (value: string) => {
    clearInterval(this.timer)

    this.timer = setTimeout(async () => {
      this.setState({
        loading: true
      })

      const res = await APostLists({
        pageSize: 50,
        pageIndex: 1,
        tenantName: value
      })

      if (res.success) {
        const selectedOptions = this.state.options?.filter(item => this.state.value.includes(item.value)) || []
        const filterOptions = res.data?.values?.filter((item) => !this.state.value.includes(item.tenantId)) || []
        const createNewOptions = filterOptions.map(item => {
          return { label: item.tenantName, value: item.tenantId, key: item.tenantId }
        })
        this.setState({
          options: selectedOptions.concat(createNewOptions),
          loading: false
        })
      } else {
        this.setState({
          loading: false
        })
      }
    }, 200)
  }

  onChange = (value: number | number[]) => {
    if (isArray(value)) {
      this.props.onChange(value)
      this.setState({
        value
      })
    } else {
      this.props.onChange([value])
      this.setState({
        value: [value]
      })
    }
  }

  render() {
    let notFoundContent = null
    const { loading, options } = this.state
    if (loading) {
      notFoundContent = <Spin />
    } else if (options?.length === 0) {
      notFoundContent = <Empty />
    }
    return (
      <Select<number[] | number>
        options={options}
        onSearch={this.onSelect}
        placeholder="Please select tenant"
        showSearch
        filterOption={false}
        mode={this.props.multiple ? 'multiple' : undefined}
        notFoundContent={notFoundContent}
        onChange={this.onChange}
        allowClear
        defaultValue={this.state.defaultValue}
      ></Select>
    )
  }
}